
<template>
  <intersect @enter="animate = true" :threshold="[0, 0.25, 0.5, 0.75, 1]">
    <div
      class="memberTabsContainer container fadeUp"
      :class="animate ? 'animate' : ''"
    >
      <div class="memberTabsInner">
        <swiper
          class="memberTabs"
          ref="memberTabs"
          :options="swiperTabsOptions"
        >
          <swiper-slide v-for="memberTab in tabsData" :key="memberTab.id">
            <div
              class="memberTab noto-semibold"
              @click="memberFunction(memberTab.id)"
              :class="activeMember == memberTab.id ? 'active' : ''"
              v-if="memberTab.members !== null && memberTab.file == ''"
            >
              {{ memberTab.title }}
            </div>
            <a
              class="memberTab link noto-semibold"
              :href="memberTab.file"
              target="_blank"
              :class="activeMember == memberTab.id ? 'active' : ''"
              v-if="memberTab.members !== null && _.size(memberTab.file)"
              >{{ memberTab.title }}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 25 25"
              >
                <path
                  id="Subtraction_153"
                  data-name="Subtraction 153"
                  d="M12.5,25c-4.883,0-7.9-.836-9.773-2.711S0,17.392,0,12.5C0,7.7.857,4.705,2.781,2.781S7.7,0,12.5,0c4.893,0,7.912.839,9.791,2.722S25,7.614,25,12.5s-.836,7.916-2.711,9.792S17.395,25,12.5,25ZM8.219,17.5h0v2.306h8.553V17.5ZM7.689,9.351a.679.679,0,0,0-.65.424.618.618,0,0,0,.16.686l4.832,4.57a.694.694,0,0,0,.482.188A.717.717,0,0,0,13,15.03l4.826-4.57a.618.618,0,0,0,.16-.686.679.679,0,0,0-.65-.424H14.586V5.646A.67.67,0,0,0,13.9,5h-2.76a.67.67,0,0,0-.687.648V9.351Z"
                  fill="#9e9e9e"
                ></path>
              </svg>
            </a>

            <!--                    <a-->
            <!--                            class="memberTab noto-semibold memberTabLined"-->
            <!--                            :class="activeMember == memberTab.id ? 'active' : ''"-->
            <!--                            v-if="memberTab.members == null"-->
            <!--                            :href="memberTab.url"-->
            <!--                    >-->
            <!--                        {{memberTab.title}}-->
            <!--                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">-->
            <!--                            <path id="Subtraction_153" data-name="Subtraction 153" d="M12.5,25c-4.883,0-7.9-.836-9.773-2.711S0,17.392,0,12.5C0,7.7.857,4.705,2.781,2.781S7.7,0,12.5,0c4.893,0,7.912.839,9.791,2.722S25,7.614,25,12.5s-.836,7.916-2.711,9.792S17.395,25,12.5,25ZM8.219,17.5h0v2.306h8.553V17.5ZM7.689,9.351a.679.679,0,0,0-.65.424.618.618,0,0,0,.16.686l4.832,4.57a.694.694,0,0,0,.482.188A.717.717,0,0,0,13,15.03l4.826-4.57a.618.618,0,0,0,.16-.686.679.679,0,0,0-.65-.424H14.586V5.646A.67.67,0,0,0,13.9,5h-2.76a.67.67,0,0,0-.687.648V9.351Z" fill="#9e9e9e"></path>-->
            <!--                        </svg>-->
            <!--                    </a>-->
          </swiper-slide>
        </swiper>
        <div
          class="memberTabsSliderContainer"
          :class="animateMember ? 'animate' : ''"
        >
          <swiper
            class="memberTabsSlider"
            ref="memberTabsSlider"
            :options="swiperMembersOptions"
          >
            <template v-for="(member, index) in itemData">
              <swiper-slide :key="member.id" v-if="memberParser(index)">
                <router-link
                  :to="$store.getters.getSingleUrl(member)"
                  class="memberTabItem"
                >
                  <div class="imgPlace">
                    <div class="memberImgHover">
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25.001"
                          height="25"
                          viewBox="0 0 25.001 25"
                        >
                          <g
                            id="Group_1339"
                            data-name="Group 1339"
                            transform="translate(-353 -4901.998)"
                          >
                            <path
                              id="Subtraction_27"
                              data-name="Subtraction 27"
                              d="M5623.5-9566c-4.883,0-7.9-.836-9.776-2.71s-2.723-4.9-2.723-9.79c0-4.8.858-7.8,2.781-9.719s4.92-2.781,9.718-2.781c4.891,0,7.91.84,9.79,2.723s2.712,4.895,2.712,9.777-.836,7.914-2.712,9.79S5628.395-9566,5623.5-9566Zm-.5-11.5v5.5h2v-5.5h5.5v-2H5625v-5.5h-2v5.5h-5.5v2Z"
                              transform="translate(-5258 14493)"
                              fill="#fff"
                            ></path>
                          </g>
                        </svg>
                        Bio
                      </div>
                    </div>
                    <img
                      :src="
                        _.get(member, [
                          'images',
                          Object.keys(member.images)[0],
                          'url',
                        ])
                      "
                      :alt="member.title"
                      class="img-absolute"
                    />
                  </div>
                  <div class="ttl noto-semibold">{{ member.title }}</div>
                  <div class="descr">
                    {{ member.position }}
                  </div>
                </router-link>
              </swiper-slide>
            </template>
          </swiper>
          <div class="memberSliderPrev">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12.013"
              height="21.906"
              viewBox="0 0 12.013 21.906"
            >
              <g
                id="Group_70"
                data-name="Group 70"
                transform="translate(42.561 -19626.655) rotate(-90)"
              >
                <path
                  id="Path_61"
                  data-name="Path 61"
                  d="M0,9.892,9.892,0"
                  transform="translate(-19637.607 -41.5)"
                  fill="none"
                  stroke="#444958"
                  stroke-linecap="round"
                  stroke-width="1.5"
                ></path>
                <path
                  id="Path_60"
                  data-name="Path 60"
                  d="M9.892,9.892,0,0"
                  transform="translate(-19647.5 -41.5)"
                  fill="none"
                  stroke="#444958"
                  stroke-linecap="round"
                  stroke-width="1.5"
                ></path>
              </g>
            </svg>
          </div>
          <div class="memberSliderNext">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12.013"
              height="21.906"
              viewBox="0 0 12.013 21.906"
            >
              <g
                id="Group_70"
                data-name="Group 70"
                transform="translate(42.561 -19626.655) rotate(-90)"
              >
                <path
                  id="Path_61"
                  data-name="Path 61"
                  d="M0,9.892,9.892,0"
                  transform="translate(-19637.607 -41.5)"
                  fill="none"
                  stroke="#444958"
                  stroke-linecap="round"
                  stroke-width="1.5"
                ></path>
                <path
                  id="Path_60"
                  data-name="Path 60"
                  d="M9.892,9.892,0,0"
                  transform="translate(-19647.5 -41.5)"
                  fill="none"
                  stroke="#444958"
                  stroke-linecap="round"
                  stroke-width="1.5"
                ></path>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </intersect>
</template>

<script>
import Intersect from "vue-intersect";
export default {
  props: {
    itemData: {
      type: Array,
      require: true
    },
    tabsData: {
      type: Array,
      require: true
    }
  },
  components: { Intersect },
  data() {
    return {
      swiperTabsOptions: {
        slidesPerView: "auto",
        freeMode: true
      },
      animate: false,
      swiperMembersOptions: {
        speed: 800,
        spaceBetween: 20,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        slidesOffsetAfter: 0,
        watchOverflow: true,
        navigation: {
          nextEl: ".memberSliderNext",
          prevEl: ".memberSliderPrev"
        },
        breakpoints: {
          320: {
            spaceBetween: 15,
            slidesPerView: 1.2
          },
          500: {
            spaceBetween: 15,
            slidesPerView: 2.5
          },
          768: {
            spaceBetween: 15,
            slidesPerView: 3.5
          },
          1023: {
            spaceBetween: 20,
            slidesPerView: 4.5
          },
          1365: {
            spaceBetween: 20,
            slidesPerView: 5
          },
          1440: {
            spaceBetween: 20,
            slidesPerView: 5.7
          },
          1680: {
            spaceBetween: 20,
            slidesPerView: 6
          }
        }
      },
      activeMember: 1,
      animateMember: true
    };
  },
  methods: {
    memberFunction(id) {
      this.animateMember = false;
      setTimeout(() => {
        this.activeMember = id;
      }, 400);
      setTimeout(() => {
        this.animateMember = true;
      }, 450);

      // this.swiperActivation()
    },
    takeFirstId() {
      this.activeMember = _.get(this.tabsData, '0.id');
    },
    memberParser(index) {
      return this.itemData[index].management_category.includes(
        this.activeMember
      );
    }
  },
  computed: {
    getMembers() {
      return this.$store.getters.getMembers;
    }
  },
  mounted() {
    this.takeFirstId();
  }
};
</script>

<style >
.memberTab.link::after {
  display: none;
}
.memberTab svg {
  margin-left: 10px;
}
.memberTab svg path {
  transition: 0.6s;
}
.memberTab.link:hover svg path {
  fill: #ed1651;
}
</style>
